import Route from '@ember/routing/route';

export default class CoachingIndexRoute extends Route {}
